export enum QUERY_KEYS {
  // Payments related queries
  PKG_PAYMENTS = 'pkg-payments',
  // Stats related queries
  STATS = 'stats',
  PACKAGES_STATS = 'packages-stats',
  USER_PACKAGES = 'user-packages',
  PACKAGE_PAYMENTS_SUMMARY = 'package-payments-summary',
  BACKOFFICE_USER_PACKAGES = 'backoffice-user-packages',
  PACKAGE = 'package',
  LOGGED_USER = 'logged-user',
  PKGS_BY_FILTER = 'pkgs-by-filter',
  // Package requests related queries
  PACKAGE_REQUESTS = 'package-requests',
  PACKAGE_REQUESTS_FEES = 'package-requests-fees',
  PACKAGE_REQUESTS_STATS = 'package-requests-stats',
  UNITE_PACKAGE = 'unite-packages',
  USER_PACKAGE_REQUESTS = 'user-package-requests',

  // Addresses related queries
  ADDRESSES = 'addresses',
  PLACES_CITIES = 'places-cities',
  PLACES_STREETS = 'places-streets',

  // Affiliate related queries
  AFFILIATE_USER = 'affiliate-user',
  AFFILIATES = 'affiliates',
  AFFILIATE_COUPONS = 'affiliate-coupons',
  COUPONS = 'coupons',

  // Shipping related queries
  PARCEL_STATUS = 'parcel-status',

  // Currency related queries
  CURRENCY_RATES = 'currency-rates',

  // Warehouse arrivals related queries
  WAREHOUSE_ARRIVALS_STATS = 'warehouse-arrivals-stats',

  // Popular brands related queries
  POPULAR_BRANDS = 'popular-brands',

  // Pickup orders related queries
  PICKUP_ORDERS = 'pickup-orders',
  USER_PICKUP_ORDERS = 'user-pickup-orders',

  // Credit related queries
  USER = 'user',
  SERVICE_REQS = 'service-reqs',

  // App config related queries
  APP_CONFIG = 'app-config',
  PICKUP_ORDER_SETTINGS = 'pickup-order-settings',
  DELAY_PACKAGES_EMAIL_SETTINGS = 'delay-packages-email-settings',

  // USA package lookups related queries
  USA_PKG_LOOKUPS = 'usa-pkg-lookups',

  // Admin data (CRUD) related queries
  ADMIN = 'admin',
  ADMIN_TABLE = 'admin-table',
  ADMIN_SAVED_SQL_QUERIES = 'admin-saved-sql-queries',
}
